import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Alert, Button, Card, Form, Input, Typography } from "antd";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthStore } from "../auth/store";

export function LoginPage() {
  const login = useAuthStore((s) => s.login);
  const sessionNotice = useAuthStore((s) => s.sessionNotice);
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true);
    setError(null);
    try {
      await login(values.username, values.password);
      const me = useAuthStore.getState().me;
      const from = (location.state as { from?: { pathname: string } } | null)?.from?.pathname;
      // a start page of "/" (roles created before the landing page) means the dashboard
      const start = !me?.start_page || me.start_page === "/" ? "/dashboard" : me.start_page;
      if (me?.password_expired) navigate("/profile", { replace: true });
      else navigate(from && from !== "/" ? from : start, { replace: true });
    } catch (e) {
      setError(e instanceof Error ? e.message : "Ошибка входа");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="wms-login" style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 16, boxSizing: "border-box", width: "100%", overflowX: "hidden" }}>
      {/* BUG-001: never wider than the screen minus the gutters; 400 px is the upper bound, not a fixed width */}
      <Card style={{ width: "100%", maxWidth: 400, minWidth: 0, borderRadius: 16, boxShadow: "var(--wms-shadow-lg)" }} styles={{ body: { padding: "clamp(20px, 6vw, 32px)" } }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
          <span style={{ width: 42, height: 42, borderRadius: 12, background: "linear-gradient(135deg, #2f6fed, #7c3aed)", display: "inline-flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 700, fontSize: 18 }}>W</span>
          <span>
            <Typography.Title level={4} style={{ margin: 0 }}>
              Вход в WMS
            </Typography.Title>
            <Typography.Text type="secondary">Управление складом</Typography.Text>
          </span>
        </div>
        {sessionNotice && !error && <Alert type="warning" message={sessionNotice} style={{ marginBottom: 16, borderRadius: 10 }} showIcon />}
        {error && <Alert type="error" message={error} style={{ marginBottom: 16, borderRadius: 10 }} showIcon />}
        <Form layout="vertical" onFinish={onFinish} initialValues={{ username: "", password: "" }} size="large">
          <Form.Item name="username" label="Логин" rules={[{ required: true, message: "Введите логин" }]}>
            <Input prefix={<UserOutlined />} autoFocus autoComplete="username" />
          </Form.Item>
          <Form.Item name="password" label="Пароль" rules={[{ required: true, message: "Введите пароль" }]}>
            <Input.Password prefix={<LockOutlined />} autoComplete="current-password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading} style={{ height: 42, fontWeight: 600 }}>
            Войти
          </Button>
        </Form>
        <Typography.Paragraph type="secondary" style={{ marginTop: 16, marginBottom: 0, fontSize: 12 }}>
          Забыли пароль? Обратитесь к администратору склада.
        </Typography.Paragraph>
      </Card>
    </div>
  );
}
